







import { defineComponent, ref } from '@vue/composition-api';
import { ResponsiveUtils } from '../../utils';

/**
 * Simple component to be used as tab e.g. for OlbTabs component.
 */
export default defineComponent({
	props: {
		title: {
			type: String,
			default: 'Tab',
		},
		tabId: {
			type: String,
			required: true,
		},
		isInitiallyOpen: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		const tabContent = ref(null);
		const isActive = ref(false);
		const responsiveUtils = new ResponsiveUtils();
		const isSmallVP = ref(responsiveUtils.isSm());
		function setIsActive(active: boolean) {
			isActive.value = active;
		}

		function resizeHandler() {
			if (!isSmallVP.value && responsiveUtils.isSm()) {
				isSmallVP.value = true;
			} else if (isSmallVP.value && responsiveUtils.isMdUp()) {
				isSmallVP.value = false;
			}
		}
		window.addEventListener('resize', resizeHandler);

		return { tabContent, isActive, setIsActive, isSmallVP };
	},
});
